export const useSavePushNotificationToken = () => {};
